import { clsx } from "clsx"
import type { ArticleTeaserModel } from "@/services/api/content/models/article-teaser-model.types"

type ArticleTeaserHeadingProps = {
  readonly className?: string
  readonly title: ArticleTeaserModel.HtmlAndText
  readonly kickerClass?: string
}

export function ArticleTeaserHeading({
  className,
  title: { html, kicker },
  kickerClass = "font-medium",
}: ArticleTeaserHeadingProps) {
  return (
    <h1
      className={clsx("wrap-break-word hyphens-manual font-heading", className)}
      data-k5a-pos="head"
    >
      {kicker !== null ? <span className={kickerClass}>{kicker} </span> : null}
      <span
        dangerouslySetInnerHTML={{
          // biome-ignore lint/style/useNamingConvention: Biome does not support
          __html: html,
        }}
      />
    </h1>
  )
}
